const VIP_AUDIENCE_VALUES = new Set([
  'vip_only',
  'vip',
  'studio_only',
  'studio',
  'subscriber_only',
  'subscribers_only',
]);

function normalizeAudienceValue(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');

  return normalized || null;
}

function isVipOnlyContent(item) {
  const audience = normalizeAudienceValue(
    item?.audience ?? item?.post_container?.audience
  );

  return audience ? VIP_AUDIENCE_VALUES.has(audience) : false;
}

export function partitionBoardItems(items = [], shouldIncludeItem) {
  const now = Date.now();
  const grouped = { published: [], queued: [] };

  items.forEach(item => {
    if (
      isVipOnlyContent(item)
      || (shouldIncludeItem && !shouldIncludeItem(item))
    ) {
      return;
    }

    const scheduledISO = item?.publishedAt ?? item?.post_container?.publishedAt;
    const scheduledMs = scheduledISO ? Date.parse(scheduledISO) : NaN;
    const isScheduled = Number.isFinite(scheduledMs) && scheduledMs > now;

    if (isScheduled) {
      grouped.queued.push(item);
    } else {
      grouped.published.push(item);
    }
  });

  grouped.queued.sort((a, b) => {
    const aDate = Date.parse(a?.publishedAt ?? a?.post_container?.publishedAt ?? '');
    const bDate = Date.parse(b?.publishedAt ?? b?.post_container?.publishedAt ?? '');
    return aDate - bDate;
  });

  return grouped;
}
